import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { routerList } from '../constants/router'

export default function Routes() {
    return (
        <Switch>
            {routerList.map((obj, index) => (
                <Route key={index} exact path={obj.router}>
                    {obj.page}
                </Route>
            ))}
        </Switch>
    )
}

